module.exports = __webpack_public_path__ + "static/Oculus-dc70ccebfe2750c776c044d5b2b5bb83.mp4";